var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncProd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "growth_9852395",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.731,
    height: 31.735,
    viewBox: "0 0 31.731 31.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48bed9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787cfe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M8.4,15.808A7.4,7.4,0,1,0,1,8.4a7.4,7.4,0,0,0,7.4,7.4Zm0-12.692A5.288,5.288,0,1,1,3.115,8.4,5.288,5.288,0,0,1,8.4,3.115Z",
    transform: "translate(-1 -0.996)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M7.476,9.463l3.363,2.253,1.174-1.756-2.9-1.936V5H7V8.586A1.058,1.058,0,0,0,7.476,9.463Z",
    transform: "translate(-0.654 -0.765)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M31.673,27.442H29.557V11.577h2.115a1.058,1.058,0,0,0,.941-1.534l-3.755-7.51a2.761,2.761,0,0,0-4.95,0l-3.755,7.51a1.058,1.058,0,0,0,.941,1.534h2.115V27.442H20.038V16.865a1.058,1.058,0,0,0-1.058-1.058H14.75a1.058,1.058,0,0,0-1.058,1.058V27.442H10.519V21.1a1.058,1.058,0,0,0-1.058-1.058H5.231A1.058,1.058,0,0,0,4.173,21.1v6.346H2.058A1.058,1.058,0,0,0,1,28.5v1.587a2.644,2.644,0,0,0,2.644,2.644H30.086a2.644,2.644,0,0,0,2.644-2.644V28.5A1.058,1.058,0,0,0,31.673,27.442Zm-7.4-17.981h-1.46L25.8,3.475a.677.677,0,0,1,1.163,0l2.993,5.986H28.5a1.058,1.058,0,0,0-1.058,1.058V27.442H25.327V10.519A1.058,1.058,0,0,0,24.269,9.462Zm-8.461,8.461h2.115v9.519H15.808ZM6.288,22.154H8.4v5.288H6.288Zm24.327,7.933a.529.529,0,0,1-.529.529H3.644a.529.529,0,0,1-.529-.529v-.529h27.5Z",
    transform: "translate(-1 -0.996)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncProd);
export default __webpack_public_path__ + "static/media/inc-prod.220e4a3d4a8e1f4985b7cca1e9d39230.svg";
export { ForwardRef as ReactComponent };